import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";

// Определяем пропсы

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-skeleton',
  props: {
  width: {
    type: String,
    default: "100%", // Ширина по умолчанию
  },
  height: {
    type: String,
    default: "16px", // Высота по умолчанию
  },
  animated: {
    type: Boolean,
    default: true, // Анимация включена по умолчанию
  },
  borderRadius: {
    type: String,
    default: "4px", // Радиус скругления
  },
},
  setup(__props) {

const props = __props;



// Вычисляем стиль скелетона
const skeletonStyle = computed(() => ({
  width: props.width,
  height: props.height,
  borderRadius: props.borderRadius,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["skeleton", { 'skeleton-animated': __props.animated }]),
    style: _normalizeStyle(skeletonStyle.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})